
import Vue,{PropType} from "vue";

export default Vue.extend({
   props:{
	 url:{
		// required: true,
		type: String,
		default:'https://pic.rmb.bdstatic.com/bjh/down/d73323fe1acac8a420c303062bcca9a2.png'
	 },
	 size:{
		type:Number,
		default:150
	 }
   },
  

})
